// ─── A news photo, or a publisher's logo standing in for one ────────────────
//
// Many publishers serve their logo when an article has no picture of its own.
// A logo is not content: rendered at the size of a photo it is a giant brand
// mark over a headline (Yahoo Finance's, in the 06/10/2026 check · sprint 14,
// 2.2). Such a card is shown as the compact card, with no image.
//
// Two checks. By address, before anything loads (the files below are known
// logos). By size, once the image has loaded: a picture too small to be a
// photo, or a banner far wider than any news photo, is a logo whatever its
// name. Pixel content is not read · cross-origin images cannot be.

export function isLogoUrl(url) {
  if (!url) return true;
  const u = String(url).toLowerCase();
  return (
    u.includes("static2.finnhub.io/file/finnhub/logo") ||  // Finnhub source-logo cache (Reuters, etc.)
    u.includes("logobbg")                               ||  // Bloomberg logo file
    u.includes("cnbc_versant_share")                    ||  // CNBC fallback share image
    u.includes("s.yimg.com/rz/stage/")                  ||  // Yahoo Finance brand artwork
    /yahoo_finance_[a-z]{2}-[a-z]{2}/.test(u)           ||  // yahoo_finance_en-US_h_p_finance_2.png
    /[/_-]logos?[/._-]/.test(u)                         ||  // generic /logo/ or _logo_ segments
    /_logo\.(png|jpe?g|svg|webp)(\?|$)/.test(u)         ||  // *_logo.ext
    u.includes("default-image")                         ||
    u.includes("placeholder")
  );
}

// Smaller than this on either side, an image is an icon, not a news photo.
export const MIN_PHOTO_W = 300;   // the narrowest card shows an image ~350px wide
export const MIN_PHOTO_H = 150;
// Wider than this (width ÷ height), it is a banner or a word mark. News photos
// run 4:3 to 2:1.
export const MAX_PHOTO_RATIO = 2.6;

/** True when a loaded image's own size says it is not a photo. */
export function looksLikeLogo(width, height) {
  if (!(width > 0) || !(height > 0)) return false;
  return width < MIN_PHOTO_W || height < MIN_PHOTO_H || width / height > MAX_PHOTO_RATIO;
}
